import React from "react";
import LegalPage from "@/components/LegalPage";
import { useTranslation } from "@/lib/i18n";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  return (
    <LegalPage
      title={t("legal.privacy.title")}
      lastUpdated={t("legal.privacy.last_updated")}
      testId="privacy-page"
      intro={t("legal.privacy.intro")}
      sections={[
        { heading: t("legal.privacy.s1_h"), body: [t("legal.privacy.s1_b1"), t("legal.privacy.s1_b2"), t("legal.privacy.s1_b3"), t("legal.privacy.s1_b4")] },
        { heading: t("legal.privacy.s2_h"), body: t("legal.privacy.s2_b") },
        { heading: t("legal.privacy.s3_h"), body: t("legal.privacy.s3_b") },
        { heading: t("legal.privacy.s4_h"), body: t("legal.privacy.s4_b") },
        { heading: t("legal.privacy.s5_h"), body: t("legal.privacy.s5_b") },
      ]}
    />
  );
}
